import genders from '../dynamics/genders.json'
import generalLedgers from '../dynamics/general-ledgers.json'
import languages from '../dynamics/languages.json'
import paymentConditions from '../dynamics/payment-conditions.json'
import paymentTerms from '../dynamics/payment-terms.json'
import permission from '../dynamics/permission.json'
import roles_permission from '../dynamics/roles-permission.json'
import roles from '../dynamics/roles.json'
import userRoles from '../dynamics/user-roles.json'
import vatTypes from '../dynamics/vat-types.json'
import { convertToTitle } from '../helpers/common.js'

export const Genders = genders
export const GeneralLedgers = generalLedgers
export const Languages = languages
export const PaymentConditions = paymentConditions
export const PaymentTerms = paymentTerms
export const Roles = roles
export const VatTypes = vatTypes

const UserRoles = userRoles.map((role) => ({
    id: role.name,
    name: convertToTitle(role.id),
}))

const Permission = permission.map((permission) => (
    {
        id: permission?.name?.name,
        name: convertToTitle(permission?.name?.description),
    }
))

const RolePermission = roles_permission.map((rp) => (
    {
        id: rp.id,
        value: rp.name,
    }
))

const TextTemplateTypes = [
    {
        name: "footer",
        id: 1,
    },
    {
        name: "header",
        id: 2,
    }
]


const findVendorPaymentTermById = (id) => PaymentTerms.find(term => term.id === id)?.name

const ERP_CURRENCY = 'EUR'
const ERP_DEFAULT_LANGUAGE_CODE = 'nl'
const CANCELLATION_FEE_MARGIN = 40
const CLIENT_ARTWORK_UPLOAD_OFFSET_DAYS = 5
const CLIENT_PROOF_APPROVAL_OFFSET_DAYS = 1

export {
    CANCELLATION_FEE_MARGIN, CLIENT_ARTWORK_UPLOAD_OFFSET_DAYS,
    CLIENT_PROOF_APPROVAL_OFFSET_DAYS, ERP_CURRENCY, ERP_DEFAULT_LANGUAGE_CODE, findVendorPaymentTermById, Permission,
    RolePermission, TextTemplateTypes, UserRoles
}
